// extracted by mini-css-extract-plugin
export default {"wrapper":"top-editor-sections-connection_wrapper__ghpJT","section":"top-editor-sections-connection_section__XJeiU"};